const ASSET_TYPES = [
  {
    key: 'Audio',
    displayName: 'Audio',
  },
  {
    key: 'Code',
    displayName: 'Code',
  },
  {
    key: 'Documents',
    displayName: 'Documents',
  },
  {
    key: 'Images',
    displayName: 'Images',
  },
  {
    key: 'OTHER',
    displayName: 'Other',
  },
];

export default ASSET_TYPES;
